export default __webpack_public_path__ + "static/logo-9264681a500c5396ba8f5aec4df3b36c.png";